import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getFraseSeleccionAplicacionByIdService,
  getFrasesSeleccionAplicacionService,
  toggleFraseSeleccionAplicacionActiveService,
  updateFraseSeleccionAplicacionService,
} from "../../services/frasesSeleccionAplicacion/frasesSeleccionAplicacion.service";

export const getFrasesSeleccionAplicacionThunk = createAsyncThunk(
  "frasesSeleccionAplicacion/getAll",
  async ({ page = 1, search = "" } = {}, { rejectWithValue }) => {
    try {
      return await getFrasesSeleccionAplicacionService(page, search);
    } catch (error) {
      if (error.response?.status === 404) {
        return rejectWithValue("Página no válida");
      }
      return rejectWithValue(
        error.response?.data?.detail ||
          error.response?.data?.message ||
          "Error al obtener frases",
      );
    }
  },
);

export const getFraseSeleccionAplicacionByIdThunk = createAsyncThunk(
  "frasesSeleccionAplicacion/getById",
  async (id, { rejectWithValue }) => {
    try {
      return await getFraseSeleccionAplicacionByIdService(id);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.detail ||
          error.response?.data?.message ||
          "Error al obtener frase",
      );
    }
  },
);

export const updateFraseSeleccionAplicacionThunk = createAsyncThunk(
  "frasesSeleccionAplicacion/update",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      return await updateFraseSeleccionAplicacionService(id, payload);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.detail ||
          error.response?.data?.message ||
          "Error al actualizar frase",
      );
    }
  },
);

export const toggleFraseSeleccionAplicacionActiveThunk = createAsyncThunk(
  "frasesSeleccionAplicacion/toggleActive",
  async (id, { rejectWithValue }) => {
    try {
      return await toggleFraseSeleccionAplicacionActiveService(id);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.detail ||
          error.response?.data?.message ||
          "Error al cambiar estado",
      );
    }
  },
);
